export var flexibleLayoutContainer = function (_a) {
    var direction = _a.direction, wrap = _a.wrap, justifyContent = _a.justifyContent, alignContent = _a.alignContent, justifyItems = _a.justifyItems, alignItems = _a.alignItems;
    return ({
        display: 'flex',
        flexDirection: direction,
        flexWrap: wrap,
        justifyContent: justifyContent,
        alignContent: alignContent,
        justifyItems: justifyItems,
        alignItems: alignItems,
    });
};
export var flexibleLayoutItem = function (_a) {
    var order = _a.order, grow = _a.grow, shrink = _a.shrink, basis = _a.basis, justifySelf = _a.justifySelf, alignSelf = _a.alignSelf;
    return ({
        order: order,
        flexGrow: grow,
        flexShrink: shrink,
        flexBasis: basis,
        justifySelf: justifySelf,
        alignSelf: alignSelf,
    });
};
